import * as THREE from 'three';

export const PetrifyShader = {
    name: 'PetrifyShader',

    uniforms: {
        tDiffuse: { value: null },
        resolution: { value: new THREE.Vector2(1920, 1080) },
        strength: { value: 4.0 }, // overall crisp intensity
        gamma: { value: 0.5 },
    },

    vertexShader: /* glsl */ `
        varying vec2 vUv;
        void main() {
            vUv = uv;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        }
    `,

   fragmentShader: /* glsl */ `
    uniform sampler2D tDiffuse;
    uniform vec2 resolution;
    uniform float strength;
    uniform float gamma;

    varying vec2 vUv;

    void main() {
        vec2 px = 1.0 / resolution;

        // sample surrounding pixels
        vec3 col = texture2D(tDiffuse, vUv).rgb;
        vec3 north = texture2D(tDiffuse, vUv + vec2(0.0,  px.y)).rgb;
        vec3 south = texture2D(tDiffuse, vUv - vec2(0.0,  px.y)).rgb;
        vec3 east  = texture2D(tDiffuse, vUv + vec2( px.x, 0.0)).rgb;
        vec3 west  = texture2D(tDiffuse, vUv - vec2( px.x, 0.0)).rgb;

        // high-pass / edge detection
        vec3 edge = (north + south + east + west) * 0.25 - col;

        // sharpen by subtracting negative edges
        vec3 sharpened = col - edge * strength;

        // --- APPLY GAMMA CORRECTION HERE ---
        sharpened = pow(sharpened, vec3(gamma));

        gl_FragColor = vec4(sharpened, 1.0);
    }
`,

};

// Helper for uniforms
export function createPetrifyUniforms(
    strength = 1.0,
    resolution = new THREE.Vector2(1920, 1080)
) {
    return {
        tDiffuse: { value: null },
        resolution: { value: resolution.clone() },
        strength: { value: strength },
    };
}
